var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diagnostic-scale"},[_c('ul',_vm._l((_vm.valueRange),function(range){return _c('li',{key:'range-' + range.value,class:{ active: range.value === _vm.value },style:({ backgroundColor: range.color })},[_vm._v(" "+_vm._s(range.value)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }